export default __webpack_public_path__ + "static/media/victorops.306c7739.svg";